import AppData from '../../Model/MerchantAppData';
import BaseFirebaseRepository from './BaseFirebaseRepository';

const instances = {}
const defaultInstanceKey = Math.random()
export default class DineInTableRepository extends BaseFirebaseRepository {
    // Indicate that this repository use API instead of Firebase
    isUseAPI = true

    // constructor() {
    //     this.isUseAPI = true
    // }
    /**
     * @param {*} app
     * @return {DineInTableRepository}
     */
    static getInstance(app) {
        if (app == null) {
            // By default, use instance created from main App
            app = DineInTableRepository.context || defaultInstanceKey
        }
        if (app != null && instances[app] == null) {
            // Create a new instance
            instances[app] = new DineInTableRepository(app)
        }
        return instances[app]
    }
    getRef = () => {
        return null
    }
    getSingleRef = () => {
        // This repository uses API to load instead of Firebase, so this
        // function is not called
        return null
    }
    getBaseObject = () => {
        return {}
    }
    getApiBaseUrl = (id) => {
        return `/tables/%id%/pickup_tables?page=1`
    }
    getReloadEventKey = (id) => {
        return `dine_in_table_version_${window.table_id}.changed`
    }
    getSingleItemReloadEventKey = (id) => {
        return `dine_in_table_version_${id}.changed`
    }
    /**
     * Parse raw API response before perform any logic
     * @returns {Object}
     */
    parseRawApiResponse = (rawResponse) => {
        if (rawResponse) {
            if (rawResponse.data) {
                rawResponse = rawResponse.data
            }
            if (!Array.isArray(rawResponse)) {
                return [rawResponse]
            }
            else {
                return rawResponse
            }
        }
        return []
    }
}
